/** Monta o link direto da sala usando a origem pública configurada. */
export function roomUrl(code: string, publicAppUrl = ''): string {
  const base = publicAppUrl.trim() || window.location.origin;
  const normalized = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${normalized}/sala/${code.toUpperCase()}`;
}

export async function copyText(text: string): Promise<boolean> {
  try {
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text);
      return true;
    }
  } catch {
    // Segue para o método alternativo.
  }

  try {
    const area = document.createElement('textarea');
    area.value = text;
    area.setAttribute('readonly', '');
    area.style.position = 'fixed';
    area.style.opacity = '0';
    document.body.appendChild(area);
    area.select();
    const copied = document.execCommand('copy');
    document.body.removeChild(area);
    return copied;
  } catch {
    return false;
  }
}

export function canShare(): boolean {
  return typeof navigator !== 'undefined' && typeof navigator.share === 'function';
}

/** Web Share API quando disponível; caso contrário, cópia. */
export async function shareRoom(
  url: string,
  title: string,
  text: string,
): Promise<'shared' | 'copied' | 'failed'> {
  if (canShare()) {
    try {
      await navigator.share({ title, text, url });
      return 'shared';
    } catch (error) {
      // Cancelamento do usuário não é falha.
      if (error instanceof DOMException && error.name === 'AbortError') return 'failed';
    }
  }
  return (await copyText(url)) ? 'copied' : 'failed';
}
